import { getAttachmentsForAsset } from '../services/attachment';
import { insertAttachmentIntoDocument } from '../services/document';

export const DISMISS_ATTACHMENT_ERROR = 'DISMISS_ATTACHMENT_ERROR';
export const INSERT_ATTACHMENT = 'INSERT_ATTACHMENT';
export const INSERT_ATTACHMENT_FAIL = 'INSERT_ATTACHMENT_FAIL';
export const LOADING_ATTACHMENT = 'LOADING_ATTACHMENT';
export const LOAD_ATTACHMENTS_FOR_ASSET = 'LOAD_ATTACHMENTS_FOR_ASSET';

export const dismissAttachmentError = () => ({
  type: DISMISS_ATTACHMENT_ERROR
});

export const insertAttachment = attachment => dispatch => {
  insertAttachmentIntoDocument(attachment)
    .then(() =>
      dispatch({
        type: INSERT_ATTACHMENT,
        attachment
      })
    )
    .catch(error =>
      dispatch({
        type: INSERT_ATTACHMENT_FAIL,
        error
      })
    );
};

export const loadingAttachment = loading => ({
  type: LOADING_ATTACHMENT,
  loading
});

export const loadAttachmentsForAsset = asset => dispatch => {
  dispatch(loadingAttachment(true));
  getAttachmentsForAsset(asset.id).then(attachments =>
    dispatch({
      type: LOAD_ATTACHMENTS_FOR_ASSET,
      attachments
    })
  );
};



// WEBPACK FOOTER //
// ./src/actions/attachment.js